import {
  SettingOutlined,
  ScissorOutlined,
  ShoppingOutlined,
  CoffeeOutlined,
  BookOutlined,
  VideoCameraOutlined,
  CalendarOutlined,
  DollarOutlined,
  BankOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  HeartOutlined,
  ShopOutlined,
  RocketOutlined,
  ForkOutlined,
  ProductOutlined,
} from "@ant-design/icons";

export const numberStatus = [
  {
    id: 1,
    status: "Active",
  },
  {
    id: 2,
    status: "Being Reviewed",
  },
  {
    id: 3,
    status: "Pending",
  },
  {
    id: 4,
    status: "Offline",
  },
  {
    id: 5,
    status: "Warned",
  },
  {
    id: 6,
    status: "Banned",
  },
  {
    id: 7,
    status: "Connected",
  },
  {
    id: 8,
    status: "Unavailable",
  },
  {
    id: 9,
    status: "Message Limit Reached",
  },
  {
    id: 10,
    status: "Pending",
  },
];

export const TemplateLeftSideList = [
  // {
  //   id: 1,
  //   name: 'Phone Number',
  // },
  {
    id: 1,
    name: "Display Name",
  },
  {
    id: 2,
    name: "Status",
  },
  {
    id: 3,
    name: "Quality Rating",
  },
  {
    id: 4,
    name: "Messaging Limit",
  },
  {
    id: 5,
    name: "Country",
  },
];

export const daily_messaging_limit = {
  TIER_UNKNOWN: "Unavailable",
  TIER_50: 50,
  TIER_100: 100,
  TIER_250: 250,
  TIER_1K: 1000,
  TIER_2K: 2000,
  TIER_10K: 10000,
  TIER_100K: 100000,
  TIER_UNLIMITED: "Unlimited",
};

export const quality_rating = {
  UNKNOWN: "Unknown",
  GREEN: "High",
  RED: "Low",
  YELLOW: "Medium",
};

export const quality_rating_styles = {
  High: "var(--primary)",
  Medium: "var(--secondary)",
  Low: "#f96056",
  Unknown: "var(--primary)",
};

const statusColor = {
  Connected: "green",
  Pending: "orange",
  Offline: "default",
  Warned: "orange",
  "Message limit reached": "cyan",
  Banned: "red",
  Unavailable: "default",
  Transferred: "gold",
  Unverified: "default",
};

const status = [
  "Connected",
  "Pending",
  "Offline",
  "Warned",
  "Message limit reached",
  "Banned",
  "Unavailable",
  "Transferred",
  "Unverified",
];

export const statusKeys = {
  "-1": { text: "#ff4d4f", backgroundColor: "#FDE6E6", label: "Disconnected" },
  1: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Banned" },
  2: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Deleted" },
  3: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Disconnected" },
  4: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Flagged" },
  5: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Migrated" },
  6: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Pending" },
  7: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Rate Limited" },
  8: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Restricted" },
  9: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Unknown" },
  10: { text: "#25C277", backgroundColor: "#EEFBF4", label: "Connected" },
  11: { text: "#faad14", backgroundColor: "#FDE6E6", label: "Unverified" },

  // STATUS_BANNED: 1,
  // STATUS_DELETED: 2,
  // STATUS_DISCONNECTED: 3,
  // STATUS_FLAGGED: 4,
  // STATUS_MIGRATED: 5,
  // STATUS_PENDING: 6,
  // STATUS_RATE_LIMITED: 7,
  // STATUS_RESTRICTED: 8,
  // STATUS_UNKNOWN: 9,
  // STATUS_UNVERIFIED: 11,
};

// const statusIcon = {
//   Connected: <CheckCircleTwoTone twoToneColor="#52c41a" />,
//   Pending: <SyncOutlined spin style={{ color: "#faad14" }} />,
//   Offline: <CloseCircleTwoTone twoToneColor="#bfbfbf" />,
//   Warned: <ExclamationCircleTwoTone twoToneColor="#faad14" />,
//   "Message limit reached": <CheckCircleTwoTone twoToneColor="#13c2c2" />,
//   Banned: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
//   Unavailable: <CloseCircleTwoTone twoToneColor="#bfbfbf" />,
//   Transferred: <ExclamationCircleTwoTone twoToneColor="#faad14" />,
//   Unverified: <ExclamationCircleTwoTone twoToneColor="#bfbfbf" />,
// };

// export const categories = [
//   { value: "automotive", label: "Automotive", icon: SettingOutlined },
//   {
//     value: "beauty_spa_salon",
//     label: "Beauty, spa & salon",
//     icon: ScissorOutlined,
//   },
//   { value: "clothing", label: "Clothing", icon: ShoppingOutlined },
//   { value: "food_groceries", label: "Food & groceries", icon: CoffeeOutlined },
//   { value: "education", label: "Education", icon: BookOutlined },
//   { value: "entertainment", label: "Entertainment", icon: VideoCameraOutlined },
//   {
//     value: "event_planning_service",
//     label: "Event planning & service",
//     icon: CalendarOutlined,
//   },
//   {
//     value: "finance_banking",
//     label: "Finance & banking",
//     icon: DollarOutlined,
//   },
//   { value: "public_service", label: "Public service", icon: BankOutlined },
//   { value: "hotel_lodging", label: "Hotel & lodging", icon: HomeOutlined },
//   {
//     value: "medical_health",
//     label: "Medical & health",
//     icon: MedicineBoxOutlined,
//   },
//   { value: "charity", label: "Charity", icon: HeartOutlined },
//   {
//     value: "professional_services",
//     label: "Professional services",
//     icon: BankOutlined,
//   },
//   { value: "shopping_retail", label: "Shopping & retail", icon: ShopOutlined },
//   {
//     value: "travel_transportation",
//     label: "Travel & transportation",
//     icon: RocketOutlined,
//   },
//   { value: "restaurant", label: "Restaurant", icon: ForkOutlined },
//   { value: "others", label: "Others", icon: ProductOutlined },
// ];

// data to show on the single phone number details update
export const categories = [
  {
    id: 1,
    value: "ALCOHOL",
    name: "Alcoholic Beverages",
    icon: ProductOutlined,
  },
  {
    id: 2,
    value: "APPAREL",
    name: "Clothing and Apparel",
    icon: ShoppingOutlined,
  },
  { id: 3, value: "AUTO", name: "Automotive", icon: SettingOutlined },
  {
    id: 4,
    value: "BEAUTY",
    name: "Beauty, Spa and Salon",
    icon: ScissorOutlined,
  },
  { id: 5, value: "EDU", name: "Education", icon: BookOutlined },
  {
    id: 6,
    value: "ENTERTAIN",
    name: "Entertainment",
    icon: VideoCameraOutlined,
  },
  {
    id: 7,
    value: "EVENT_PLAN",
    name: "Event Planning and Service",
    icon: CalendarOutlined,
  },
  {
    id: 8,
    value: "FINANCE",
    name: "Finance and Banking",
    icon: DollarOutlined,
  },
  { id: 9, value: "GOVT", name: "Public Service", icon: BankOutlined },
  { id: 10, value: "GROCERY", name: "Food and Grocery", icon: CoffeeOutlined },
  {
    id: 11,
    value: "HEALTH",
    name: "Medical and Health",
    icon: MedicineBoxOutlined,
  },
  { id: 12, value: "HOTEL", name: "Hotel and Lodging", icon: HomeOutlined },
  { id: 13, value: "NONPROFIT", name: "Non-profit", icon: HeartOutlined },
  {
    id: 14,
    value: "ONLINE_GAMBLING",
    name: "Online Gambling & Gaming",
    icon: ProductOutlined,
  },
  {
    id: 15,
    value: "OTC_DRUGS",
    name: "Over-the-Counter Drugs",
    icon: MedicineBoxOutlined,
  },
  { id: 16, value: "OTHER", name: "Other", icon: ProductOutlined },
  {
    id: 17,
    value: "PHYSICAL_GAMBLING",
    name: "Non-Online Gambling & Gaming (E.g. Brick and mortar)",
    icon: ProductOutlined,
  },
  {
    id: 18,
    value: "PROF_SERVICES",
    name: "Professional Services",
    icon: BankOutlined,
  },
  { id: 19, value: "RESTAURANT", name: "Restaurant", icon: ForkOutlined },
  { id: 20, value: "RETAIL", name: "Shopping and Retail", icon: ShopOutlined },
  {
    id: 21,
    value: "TRAVEL",
    name: "Travel and Transportation",
    icon: RocketOutlined,
  },
];
